import * as firebase from 'firebase';
import 'firebase/firestore';

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyCBeqPn_I3xL1JpLgZhSRF0WpwDFo7sVPw",
    authDomain: "block-heads.firebaseapp.com",
    databaseURL: "https://block-heads.firebaseio.com",
    projectId: "block-heads",
    storageBucket: "block-heads.appspot.com",
    messagingSenderId: "879792174049"
});

const auth = firebaseApp.auth(); 
const db = firebaseApp.firestore();

export { db, auth };


// WEBPACK FOOTER //
// ./src/util/firebase.js